// src/Components/Products.js
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom"; // ✅ Import Link

// 👉 Featured products (IDs same as ProductList.js)
const products = [
  { id: 7, name: "BULK", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-BULK.png" },
  { id: 8, name: "CUT", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-CUT.png" },
  { id: 11, name: "DECA", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-DECA.png" },
  { id: 9, name: "EQ", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-EQ.png" },
  { id: 12, name: "MasterP", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-MasterP.png" },
  { id: 10, name: "Primabolan", category: "INJECTABLES", image: "assets/images/Olympia_IMG/Inject-Primabolan.png" },
  { id: 22, name: "FRAG", category: "PEPTIDES", image: "assets/images/Olympia_IMG/Peptides-FRAG.png" },
  { id: 23, name: "GRP6", category: "PEPTIDES", image: "assets/images/Olympia_IMG/Peptides-GRP6.png" },
  { id: 24, name: "HGH", category: "PEPTIDES", image: "assets/images/Olympia_IMG/Peptides-HGH.png" },
  { id: 25, name: "IGF", category: "PEPTIDES", image: "assets/images/Olympia_IMG/Peptides-IGF.png" },
];

const Products = () => {
  const [index, setIndex] = useState(0);
  const itemsPerPage = 4; // showing 4 cards
  const sliderRef = useRef(null);

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) =>
        prev >= products.length - itemsPerPage ? 0 : prev + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Move slider
  useEffect(() => {
    const slider = sliderRef.current;
    if (slider) {
      slider.style.transition = "transform 0.6s ease-in-out";
      slider.style.transform = `translateX(-${index * (100 / itemsPerPage)}%)`;
    }
  }, [index]);

  const prevSlide = () => setIndex((prev) => Math.max(prev - 1, 0));
  const nextSlide = () =>
    setIndex((prev) =>
      Math.min(prev + 1, products.length - itemsPerPage)
    );

  return (
    <div className="slider-container">
      <h4 className="sub-heading">Our Featured Products</h4>
      <h2 className="main-heading">Supreme Quality</h2>

      <div className="slider-wrapper">
        <button
          className={`arrow circle left ${index === 0 ? "disabled" : ""}`}
          onClick={prevSlide}
        >
          ❮
        </button>

        <div className="slider" ref={sliderRef}>
          {products.map((product) => (
            <div key={product.id} className="slide">
              <div className="card glass">
                <div className="image-container">
                  {/* ✅ Correct product detail link */}
                  <Link to={`/product/${product.id}`}>
                    <img src={product.image} alt={product.name} />
                  </Link>
                </div>
                <div className="card-content">
                  <h3 className="name pt-0">
                    <Link to={`/product/${product.id}`}>{product.name}</Link>
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          className={`arrow circle right ${
            index >= products.length - itemsPerPage ? "disabled" : ""
          }`}
          onClick={nextSlide}
        >
          ❯
        </button>
      </div>

      {/* Dot indicators */}
      <div className="dots">
        {Array.from({ length: products.length - itemsPerPage + 1 }).map(
          (_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            ></span>
          )
        )}
      </div>
    </div>
  );
};

// ✅ export default
export default Products;
